import { Language } from "../languages/labels/language.labels";

export function validityList(lang: Language): {code: string, display: string}[] {
  return [
    { code: 'valid', display: lang.labels.valid },
    { code: 'invalid', display: lang.labels.invalid }
  ]
}

export function validationList(lang: Language): {code: string, display: string}[] {
  return [
    { code: 'validated', display: lang.labels.validated },
    { code: 'invalidated', display: lang.labels.invalidated }
  ]
}

export function validityValue(lang: Language, code: string): string {
  let validity = validityList(lang).find((item) => (item.code === code))
  return validity ? validity.display : lang.labels.undefined
}

export function validationValue(lang: Language, code: string): string {
  let validation = validationList(lang).find((item) => (item.code === code))
  return validation ? validation.display : lang.labels.undefined
}

export function validityBoolean(lang: Language, code: boolean): string {
  return code ? validityList(lang)[0].display : validityList(lang)[1].display
}
